<template>
  <!-- Mission List Popup -->
  <div>
    <el-dialog
      title="Ghi chú"
      :visible.sync="mainDialogVisible"
      :close-on-click-modal="false"
      width="900px"
      @close="$emit('close')"
    >
      <!-- <div class="das-form-container"> -->
      <div class="das-info-title">
        Thông tin đặt phòng {{ bookingInfo.booking_group_code }}
      </div>
      <hr />
      <InfoList :columns="3">
        <InfoListLabel>Tên khách</InfoListLabel>
        <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

        <InfoListLabel>Ngày đến</InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_in_date)
        }}</InfoListValue>

        <InfoListLabel>Đoàn</InfoListLabel>
        <InfoListValue>{{ bookingInfo.booking_group_name }}</InfoListValue>

        <InfoListLabel>Số điện thoại</InfoListLabel>
        <InfoListValue>{{ bookingInfo.phone_number }}</InfoListValue>

        <InfoListLabel>Ngày đi </InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_out_date)
        }}</InfoListValue>

        <InfoListLabel>Công ty, đại lý du lịch</InfoListLabel>
        <InfoListValue>{{ bookingInfo.agent_name }}</InfoListValue>
      </InfoList>
      <div class="mt-10">
        <!-- <GridVx
          ref="missionListGrid"
          :columns="cols"
          dom-layout="scroll"
          :auto-select-first-row="false"
          :auto-size-cell="true"
          :rows="rows"
          class="agGrid"
          @selectionChanged="onSelectionChange"
        /> -->
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">
                    <span>Nội dung ghi chú</span>
                  </div>
                  <textarea
                    readonly
                    :value="noteData.note"
                    style="width: 100%"
                    :rows="12"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="mainDialogVisible = false"
          >
            Đóng
          </button>
          <!-- Warnings -->
          <!-- <button
            :disabled="rowsSelected.length === 0"
            class="btn primary small outline"
            @click="deleteWarnings()"
          >
            Xóa ghi chú
          </button> -->
          <div class="flex gap-10">
            <!-- :disabled="rowsSelected.length !== 1" -->
            <button
              v-if="noteData.is_able_update_note"
              class="btn primary small"
              @click="openEditDialog()"
            >
              Sửa ghi chú
            </button>
            <button v-else class="btn primary small" @click="openAddDialog()">
              Thêm
            </button>
          </div>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      :title="isEdit ? 'Sửa ghi chú' : 'Thêm ghi chú'"
      :visible.sync="addDialogVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="resetAddDialog"
    >
      <validation-observer ref="addFormValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <!-- <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Mã ghi chú">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Mã ghi chú</span>
                    </div>
                    <el-select v-model="submitForm.code" placeholder="">
                      <el-option
                        v-for="item in warningCodeOptions"
                        :key="item.id"
                        :label="item.code"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required" name="Hiển thị ghi chú">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Hiển thị ghi chú</span>
                    </div>
                    <div class="checkbox-container">
                      <div class="checks-wrap">
                        <input
                          id="adasdvzx"
                          v-model="submitForm.display"
                          type="radio"
                          :value="1"
                        />
                        <label for="adasdvzx">Khi nhận phòng</label>
                      </div>
                      <div class="checks-wrap ml-10">
                        <input
                          id="adasdvzx2"
                          v-model="submitForm.display"
                          type="radio"
                          :value="2"
                        />
                        <label for="adasdvzx2">Khi xem giao dịch</label>
                      </div>
                      <div class="checks-wrap ml-10">
                        <input
                          id="adasdvzx3"
                          v-model="submitForm.display"
                          type="radio"
                          :value="3"
                        />
                        <label for="adasdvzx3"
                          >Khi xem chi tiết nhận phòng</label
                        >
                      </div>
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div> -->
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required" name="Nội dung ghi chú">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Nội dung ghi chú</span>
                    </div>
                    <textarea
                      v-model="submitForm.note"
                      style="width: 100%"
                      :rows="3"
                      :maxlength="addNoteMaxLength"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addDialogVisible = false"
          >
            Đóng
          </button>
          <button v-if="isEdit" class="btn primary small" @click="onUpdate()">
            Cập nhật
          </button>
          <button v-else class="btn primary small" @click="onSubmitNew()">
            Tạo mới
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  // eslint-disable-next-line no-unused-vars
  addForm,
  // eslint-disable-next-line no-unused-vars
  handleRow,
  // eslint-disable-next-line no-unused-vars
  getWarningList,
  deleteWarningsApi,
  // eslint-disable-next-line no-unused-vars
  updateWarningApi,
  updateBookingNoteApi
} from '@/api/cashier_service/postTransaction'
import { getCode } from '@/api/common/code'
import { BOOKING_STATUS } from '@/constant'
export default {
  props: {
    noteData: {
      type: Object,
      default: () => ({
        booking_id: null,
        is_able_update_note: false,
        note: ''
      })
    },
    bookingStatus: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      warningCodeOptions: [],
      mainDialogVisible: false,
      addDialogVisible: false,
      rowsSelected: [],
      isEdit: false,
      submitForm: this.noteData,
      cols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã',
          field: 'code_string',
          tooltipField: 'code_string'
        },
        {
          headerName: 'Hiển thị ghi chú',
          field: 'display',
          valueGetter: param => {
            let output = ''
            switch (param.data.display) {
              case 1:
                output = 'Khi nhận phòng'
                break
              case 2:
                output = 'Khi xem giao dịch'
                break
              case 3:
                output = 'Khi xem chi tiết nhận phòng'
                break
              default:
                break
            }
            return output
          }
        },
        {
          headerName: 'Nội dung ghi chú',
          field: 'content',
          tooltipField: 'content'
        }
      ],
      rows: [],
      // ***************************************
      cancelMessageDialog: false,
      cancelMessageForm: {
        note: null
      }
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    addNoteMaxLength() {
      // eslint-disable-next-line eqeqeq
      if (this.bookingStatus == BOOKING_STATUS.BOOKED) {
        return 100
      }
      return 254 - (this.noteData.note?.length || 0)
    }
  },
  watch: {
    cancelMessageDialog() {
      this.cancelMessageDialog
        ? null
        : this.$nullValueInObj(this.cancelMessageForm)
    },
    noteData: {
      handler(val) {
        this.submitForm = {
          ...val
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getWarningCodeOptions()
  },
  methods: {
    async onUpdate() {
      if ((await this.$vxForm.isValid(this.$refs.addFormValidator)) === false) {
        return
      }
      await updateBookingNoteApi(this.submitForm)
        .then(res => {
          const message = res.message
          this.addDialogVisible = false
          // this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$emit('updatedNoteData')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
      // this.submitForm.sub_booking_group_id = this.bookingInfo.id
      // await updateWarningApi(this.submitForm)
      //   .then(async res => {
      //     const message = res.message
      //     this.addDialogVisible = false
      //     this.attachData()
      //     this.$message({
      //       type: 'success',
      //       message: this.$t(`successMsg.${message}`)
      //     })
      //   })
      //   .catch(error => {
      //     const message = error.response?.data?.message || 'default'
      //     this.$message({
      //       type: 'error',
      //       message: this.$t(`errorMsg.${message}`)
      //     })
      //   })
    },
    openEditDialog() {
      this.isEdit = true
      this.submitForm = this.noteData
      // Object.assign(this.submitForm, this.rowsSelected[0])
      this.addDialogVisible = true
    },
    async deleteWarnings() {
      const ids = this.rowsSelected.map(item => item.id) || []
      this.$vxConfirm(this.$t('alert.deleteWarningConfirm'), () => {
        deleteWarningsApi({
          id_list: ids
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async getWarningCodeOptions() {
      const data = await getCode({
        p_code: 'WARNING_TEMP'
      })
      this.warningCodeOptions = data.data || []
    },
    async onSubmitNew() {
      if ((await this.$vxForm.isValid(this.$refs.addFormValidator)) === false) {
        return
      }
      // const url = '/cashier-service/v1/room-warning'
      // this.submitForm.sub_booking_group_id = this.bookingInfo.id
      // await addForm(url, this.submitForm)
      //   .then(async res => {
      //     const message = res.message
      //     this.addDialogVisible = false
      //     this.attachData()
      //     this.$message({
      //       type: 'success',
      //       message: this.$t(`successMsg.${message}`)
      //     })
      //   })
      //   .catch(error => {
      //     const message = error.response?.data?.message || 'default'
      //     this.$message({
      //       type: 'error',
      //       message: this.$t(`errorMsg.${message}`)
      //     })
      //   })

      await updateBookingNoteApi(this.submitForm)
        .then(res => {
          const message = res.message
          this.addDialogVisible = false
          // this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$emit('updatedNoteData')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      // const data = await getWarningList({
      //   sub_booking_group_id: this.bookingInfo.id
      // })
      // this.rows = data.data || []
      // this.rowsSelected = []
    },
    async getInitData() {
      // await this.attachData()
      this.mainDialogVisible = true
    },
    openAddDialog() {
      if (this.addNoteMaxLength <= 0) {
        this.$message({
          type: 'warning',
          message: 'Không thể thêm ghi chú do đã vượt quá 255 kí tự.'
        })
        return
      }

      this.addDialogVisible = true
      this.submitForm.note = ''
    },
    resetAddDialog() {
      // this.$nullValueInObj(this.submitForm)
      this.isEdit = false
    },
    onSelectionChange(rows) {
      this.rowsSelected = rows
    }
    // *********************************
  }
}
</script>
